// Module
var code = "<oc-form name=\"vm.form\"> <amt-content> <oc-property-row ng-required=\"true\" label-width=\"4\" value-width=\"8\" label-resource=\"stocktake.serialNumber\"> <input ng-model=\"vm.serial\" type=\"text\" style=\"text-transform:uppercase\" focus-me ng-required=\"true\" class=\"form-Control\"/> </oc-property-row> </amt-content> </oc-form>";
// Exports
module.exports = code;